import { useEffect, useRef, useState } from "react";
import { Reveal } from "../landing/Reveal";

const REELS = [
  {
    emoji: "🍜",
    title: "Midnight Ramen Drop",
    who: "@priyacooks",
    likes: "12.4K",
    grad: "from-[#F97316] via-[#8a4b2d] to-[#09090B]",
    cta: "Order ₹89",
    video: "/videos/reel-food.mp4",
    webm: "/videos/reel-food.webm",
  },
  {
    emoji: "🎓",
    title: "Crack DSA in 30 Days",
    who: "@anjalilearns",
    likes: "8.1K",
    grad: "from-[#7C3AED] via-[#3f3b8f] to-[#09090B]",
    cta: "Start Free",
    video: "/videos/reel-study.mp4",
    webm: "/videos/reel-study.webm",
  },
  {
    emoji: "👟",
    title: "Campus Thrift Haul",
    who: "@akashfits",
    likes: "5.9K",
    grad: "from-[#22C55E] via-[#8f7414] to-[#09090B]",
    cta: "Shop Look",
    video: "/videos/reel-fashion.mp4",
    webm: "/videos/reel-fashion.webm",
  },
  {
    emoji: "🏔️",
    title: "Manali Under ₹4K",
    who: "@travelbite",
    likes: "21K",
    grad: "from-[#06B6D4] via-[#14684a] to-[#09090B]",
    cta: "Book Seat",
    video: "/videos/reel-travel.mp4",
    webm: "/videos/reel-travel.webm",
  },
];

const ReelCard = ({ r, i }) => {
  const videoRef = useRef(null);
  const [videoOk, setVideoOk] = useState(true);

  useEffect(() => {
    const el = videoRef.current;
    if (!el || !videoOk) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.play().catch(() => {});
        else el.pause();
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [videoOk]);

  return (
    <div
      data-testid={`reel-${i}`}
      className={`group relative h-[420px] w-[240px] shrink-0 snap-start overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-b sm:h-[460px] sm:w-[260px] ${r.grad}`}
    >
      <span className="absolute left-1/2 top-1/3 -translate-x-1/2 text-7xl drop-shadow-2xl transition-transform duration-500 group-hover:scale-125">
        {r.emoji}
      </span>
      {videoOk && (
        <video
          ref={videoRef}
          muted
          loop
          playsInline
          preload="metadata"
          onError={() => setVideoOk(false)}
          data-testid={`reel-video-${i}`}
          className="absolute inset-0 h-full w-full object-cover"
        >
          <source src={r.webm} type="video/webm" />
          <source src={r.video} type="video/mp4" />
        </video>
      )}
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" />
      <span className="absolute right-3 top-1/3 flex flex-col items-center gap-4 text-[11px] font-semibold text-white">
        <span className="flex flex-col items-center gap-1">❤️<span className="font-jbmono text-[9px]">{r.likes}</span></span>
        <span className="flex flex-col items-center gap-1">💬<span className="font-jbmono text-[9px]">318</span></span>
        <span className="flex flex-col items-center gap-1">↗<span className="font-jbmono text-[9px]">Share</span></span>
      </span>
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-4 pt-10">
        <p className="text-sm font-bold text-white">{r.title}</p>
        <p className="font-jbmono text-[10px] text-slate-300">{r.who}</p>
        <button
          data-testid={`reel-cta-${i}`}
          className="mt-3 w-full rounded-full bg-white py-2.5 text-xs font-bold text-[#09090B] transition-transform group-hover:scale-[1.02]"
        >
          {r.cta}
        </button>
      </div>
    </div>
  );
};

export const ReelsFeed = () => (
  <section id="reels" data-testid="reels-section" className="relative py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">Reels</p>
        <h2 className="mx-auto mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          Scroll it. Love it. Buy it. Book it.
        </h2>
      </Reveal>

      <div
        data-testid="reels-scroll"
        className="no-scrollbar -mx-4 mt-12 flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 pb-4 lg:justify-center"
      >
        {REELS.map((r, i) => (
          <Reveal key={r.title} delay={0.07 * i}>
            <ReelCard r={r} i={i} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
